import React, { useEffect, useState } from 'react';
import Header from '../Components/HeaderAdmin'; // Import Header
import {
    MDBBadge,
    MDBTable,
    MDBTableHead,
    MDBTableBody,
    MDBCol,
    MDBContainer,
    MDBRow,
    MDBCard,
    MDBCardBody,
    MDBBtn
} from 'mdb-react-ui-kit';
import { BASE_URL } from '../config';

export default function DoctorRequest() {
    const [doctorList, setDoctorList] = useState([]);

    useEffect(() => {
        const fetchDoctorRequests = async () => {
            try {
                const response = await fetch(`${BASE_URL}DoctorRequest`, {
                    method: 'POST',
                    headers: {
                        'Accept': 'text/plain',
                    },
                });

                // if (!response.ok) {
                //     throw new Error('Network response was not ok');
                // }

                const data = await response.json();
                if (data.doctorList) {
                    setDoctorList(data.doctorList);
                }
                else {
                    alert(data.message);
                }
            } catch (error) {
                console.error('Error fetching doctor requests:', error);
            }
        };

        fetchDoctorRequests();
    }, []); // Empty dependency array means this effect runs once on mount

    return (
        <MDBContainer fluid className='h-custom py-5'>
            <MDBRow className='d-flex justify-content-center align-items-center h-50 m-3'>
                <MDBRow>
                    <Header /> {/* Use Header component */}
                </MDBRow>
                <MDBCol col='12' className="mt-3">
                    <MDBCard className='card-registration card-registration-2' style={{ borderRadius: '15px' }}>
                        <MDBCardBody className='p-0'>
                            <MDBTable align='middle'>
                                <MDBTableHead>
                                    <tr>
                                        <th scope='col'>Name</th>
                                        <th scope='col'>Documents</th>
                                        <th scope='col'>Email</th>
                                        <th scope='col'>Specialization</th>
                                        <th scope='col'>Address</th>
                                        <th scope='col'>Consultation Fee</th>
                                        <th scope='col'>Status</th>
                                        <th scope='col'>Actions</th>
                                    </tr>
                                </MDBTableHead>
                                <MDBTableBody>
                                    {doctorList.map((doctor, index) => (
                                        <tr key={index}>
                                            <td>
                                                <div className='d-flex align-items-center'>
                                                    <img
                                                        src={doctor.image || 'https://via.placeholder.com/45'} // Placeholder image if none provided
                                                        alt={doctor.name}
                                                        style={{ width: '45px', height: '45px' }}
                                                        className='rounded-circle'
                                                    />
                                                    <div className='ms-3'>
                                                        <p className='fw-bold mb-1'>
                                                            <b>{doctor.name || 'N/A'}</b> ({doctor.contactNumber || 'N/A'})

                                                            <p className='text-muted mb-0'>{doctor.personalEmail || 'N/A'}</p>

                                                        </p>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <a href={doctor.resume} download>
                                                    <MDBBtn color='primary' size='sm'>
                                                        Click To view  Resume
                                                    </MDBBtn>
                                                </a>
                                                <br></br>
                                                <a href={doctor.medicalDegree} download >
                                                    <MDBBtn color='primary' size='sm' className='mt-1'>
                                                        Click To view  Medical Degree
                                                    </MDBBtn></a>
                                            </td>
                                            <td>
                                                <p className='fw-normal mb-1'>{doctor.personalEmail || 'N/A'}</p>
                                            </td>
                                            <td>
                                                <p className='fw-normal mb-1'>{doctor.specialization || 'N/A'}</p>
                                            </td>
                                            <td>
                                                <p className='fw-normal mb-1'>{doctor.address || 'N/A'}</p>
                                                <p className='text-muted mb-0'>{doctor.permanentAddress || 'N/A'}</p>
                                            </td>
                                            <td>
                                                <p className='fw-normal mb-1'>{doctor.consultationFee || 'N/A'}</p>
                                            </td>
                                            <td>
                                                <MDBBadge color={doctor.status === "Pending" ? 'warning' : 'success'} pill>
                                                    {doctor.status}
                                                </MDBBadge>
                                            </td>
                                            <td>
                                                <MDBBtn color='link' rounded size='sm'>
                                                    Edit
                                                </MDBBtn>
                                            </td>
                                        </tr>
                                    ))}
                                </MDBTableBody>
                            </MDBTable>
                        </MDBCardBody>
                    </MDBCard>
                </MDBCol>
            </MDBRow>
        </MDBContainer>
    );
}
